import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const BalancePageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
